__turbopack_context__.v({
  "buttonsWrapper": "bO5qxW_buttonsWrapper",
  "description": "bO5qxW_description",
  "formHeader": "bO5qxW_formHeader",
  "formWrapper": "bO5qxW_formWrapper",
  "noAccount": "bO5qxW_noAccount",
});
